//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppMain'
  // data(){
  //   return {
  //     excludedComponents: ['goodsAddAndgoodsEdit']
  //   }
  // }
};